import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@isophi/core-legacy';
import { LoggedTeacherService } from '@isophi/mng-api';

import { HelperService } from '../../core/services/helper.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HelpComponent {
  private readonly helperService = inject(HelperService);
  private readonly authService = inject(AuthService);
  private readonly loggedTeacherService = inject(LoggedTeacherService);

  constructor() {
    this.helperService.setTitle(null, ' ');

    if (this.authService.loggedUser?.teacher?.hasVisitedManagementApp === false) {
      this.loggedTeacherService.loggedTeacherMarkManagementAppVisitedCreate().subscribe();
    }
  }
}
